import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { createFileRoute } from '@tanstack/react-router';
import DownloadOnAppStore from '@/assets/download_on_appstore.svg';
import logo from '@/assets/logo.png';
import splashImage from '@/assets/splash_image.webp';

type InviteSearch = {
  code?: string;
};

export const Route = createFileRoute('/invite')({
  validateSearch: (search): InviteSearch => {
    return {
      code: search.code as string | undefined,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const APP_ID = '6746621262';
  const appStoreURL = `https://apps.apple.com/app/id${APP_ID}`;

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const code = params.get('code');

  useEffect(() => {
    setTimeout(() => {
      location.replace(appStoreURL);
    }, 200);
  }, []);

  return (
    <>
      <Helmet>
        <meta name="apple-itunes-app" content={`app-id=${APP_ID}, app-argument=bond://invite?code=${code}`} />
      </Helmet>
      <div className="relative flex flex-row items-center justify-center py-3 px-4 w-full">
        <img src={logo} alt="Bond Logo" className="h-8 object-contain" />
      </div>
      <div className="flex flex-col items-center">
        <div className="w-full shrink grow-0 flex justify-center mb-8">
          <img src={splashImage} alt="Landing Page Visual" className="w-[320px] h-auto object-contain" />
        </div>
        <a className="mt-4" href={appStoreURL}>
          <img src={DownloadOnAppStore} alt="Download on App Store" />
        </a>
      </div>
    </>
  );
}
